var getters = {
    getQueryParam: (state) => (name) => {
        return state.queryObj[name] || '';
    }
}


export default getters;


// WEBPACK FOOTER //
// ./src/store/getters.js